// Percorso file: src/components/games/RiepilogoPartita.jsx
//
// IL RIEPILOGO DI UNA PARTITA CONCLUSA — cantiere GAMES, fetta G2, PIANO §2
// fase 7: intestazione (data, avversario, risultato) e la tabella per
// giocatore (minuti, gol, gialli, rosso), letta dal record del cassetto
// `games`. Sola lettura: il «Edit» lo offre il padre, che riporta alla
// tabella editabile (TabellaFinale) e risalva sullo stesso record. Una
// conclusa NON ricostruisce il campo: si salvano i totali, non la cronologia.
//
// Qui una `<table>` vera, a cinque colonne strette: senza comandi dentro,
// sul telefono regge (i numeri sono corti, il nome va a capo). I nomi
// arrivano dal padre (`nomi`: playerId → nome, dalla rosa dell'anno): un
// giocatore che nel frattempo non è più in rosa si mostra come «Former
// player» — nessun id di persona a schermo.

import React from "react";
import "./GamesMatch.css";

const FUORI_ROSA = "Former player";

export default function RiepilogoPartita({ record, nomi, quando, squadra, avversario }) {
  const score = record && record.score ? record.score : {};
  const players = Array.isArray(record && record.players) ? record.players : [];

  return (
    <>
      <section className="qpsc-games-summary" aria-label="Match summary">
        <span className="qpsc-games-summary__score">
          {score.us ?? "–"} &ndash; {score.them ?? "–"}
        </span>
        <span className="qpsc-games-summary__teams">
          {squadra}
          {avversario ? ` vs ${avversario}` : ""}
        </span>
        {quando && <span className="qpsc-games-summary__note">{quando}</span>}
      </section>

      {players.length === 0 ? (
        <p className="qpsc-games-rows__empty">No players were recorded for this match.</p>
      ) : (
        <div className="qpsc-games-table-wrap">
          <table className="qpsc-games-table">
            <thead>
              <tr>
                <th scope="col">Player</th>
                <th scope="col">Min</th>
                <th scope="col">Goals</th>
                <th scope="col">Yellow</th>
                <th scope="col">Red</th>
              </tr>
            </thead>
            <tbody>
              {players.map((p) => {
                const id = String(p.playerId);
                return (
                  <tr key={id}>
                    <td>{nomi.get(id) || FUORI_ROSA}</td>
                    <td>{p.minutes ?? 0}</td>
                    <td>{p.goals ?? 0}</td>
                    <td>{p.yellowCards ?? 0}</td>
                    <td>
                      {p.redCard ? (
                        <span
                          className="qpsc-games-card-mark qpsc-games-card-mark--red"
                          role="img"
                          aria-label="Sent off"
                        />
                      ) : (
                        <span aria-label="No">&mdash;</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
